import { Reveal } from "@/components/Reveal";

const stats = [
  { value: "30+", label: "Years of Practice" },
  { value: "12", label: "Disciplines" },
  { value: "∞", label: "Iterations" },
];

const Manifesto = () => (
  <section
    id="about"
    data-testid="manifesto"
    className="bg-white text-[var(--cerra-fg)] py-24 sm:py-36 px-5 sm:px-8"
  >
    <div className="mx-auto max-w-[1600px] grid grid-cols-1 lg:grid-cols-12 gap-y-14 lg:gap-x-10">
      {/* Left label column */}
      <div className="lg:col-span-2">
        <Reveal>
          <p className="text-[11px] font-bold uppercase tracking-[0.28em] text-black/40">
            02 — Manifesto
          </p>
          <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.28em] text-[var(--cerra-fg)]">
            About Cerra
          </p>
        </Reveal>
      </div>

      {/* Center content */}
      <div className="lg:col-span-7">
        <Reveal>
          <h2 className="font-head font-medium kern-tight leading-[1.05] text-[2rem] sm:text-[2.7rem] lg:text-[3.8rem]">
            Cerra Design is the{" "}
            <span className="italic font-light text-black/40">evolution</span> of
            decades of automotive and industrial design — a global studio where{" "}
            <span className="underline decoration-2 underline-offset-[6px]">
              craft
            </span>{" "}
            meets engineering.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-10 sm:grid-cols-2 max-w-2xl">
          <Reveal delay={0.05}>
            <p className="text-sm sm:text-base leading-relaxed text-black/60">
              We design vehicles, products, and experiences from the first sketch
              to the final fabricated form. Every surface is considered. Every
              tolerance is intentional.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-sm sm:text-base leading-relaxed text-black/60">
              Our work spans clay modelling, CAD &amp; Class-A surfacing, VR
              visualisation, and hands-on prototype fabrication — bridging digital
              intent and physical reality.
            </p>
          </Reveal>
        </div>
      </div>

      {/* Right stats column */}
      <div className="lg:col-span-3 lg:pl-8 lg:border-l border-[var(--cerra-border)]">
        <div className="flex flex-row lg:flex-col gap-10 lg:gap-12 flex-wrap">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div data-testid={`stat-${i}`}>
                <p className="font-head text-4xl sm:text-5xl font-light kern-tight">
                  {s.value}
                </p>
                <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.22em] text-black/40">
                  {s.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Manifesto;
